import earcut from "earcut";
export const triangulatePolygon = (xy) => {
    const trianglesIndices = earcut(xy);
    const coords = trianglesIndices.reduce((acc, pos, index) => {
        acc[index * 2] = xy[pos * 2];
        acc[index * 2 + 1] = xy[pos * 2 + 1];
        return acc;
    }, new Float32Array(trianglesIndices.length * 2));
    return new Float32Array(coords);
};
//# sourceMappingURL=utils.js.map